const RangeSliderSkeleton = () => {
  return <div className='flex flex-col gap-2' data-sentry-component="RangeSliderSkeleton" data-sentry-source-file="skeleton.tsx">
            <div className='flex flex-col gap-4'>
                <div className='h-[40px] w-full animate-pulse rounded-md bg-gray-200' />
                <div className='h-[40px] w-full animate-pulse rounded-md bg-gray-200' />
            </div>

            <div className='relative'>
                <div className='absolute left-0 top-1/2 z-10 h-5 w-5 animate-pulse rounded-full bg-gray-200' />
                <div className='w-ful mt-5 h-[4px] animate-pulse rounded-md bg-gray-200' />
                <div className='absolute right-0 top-1/2 z-10 h-5 w-5 animate-pulse rounded-full bg-gray-200' />
            </div>
        </div>;
};
export default RangeSliderSkeleton;